import { create } from "zustand";

type MetasState = {
    showGlobalSearch: boolean;
};
type MetasActions = {
    actions: {
        setShowGlobalSearch: (showGlobalSearch?: boolean) => void;
    };
};

export const useMetasStore = create<MetasState & MetasActions>()((set) => ({
    showGlobalSearch: false,
    actions: {
        setShowGlobalSearch: (showGlobalSearch = false) => set({ showGlobalSearch }),
    },
}));

export const useMetasShowGlobalSearch = () => useMetasStore((state) => state.showGlobalSearch);
export const useMetasActions = () => useMetasStore((state) => state.actions);
